import { Stack, Typography } from '@mui/material';
import { useParams } from 'react-router-dom';
import NoteItem from 'src/features/ContributionDetail/NoteFromAdmin/NoteItem';
import { useQueryGetContributionNotes } from 'src/services/queries/useQueryContribute';
import { getArrayDefault } from 'src/utils/helpers/arrayHelpers';

const NoteFromAdmin = () => {
  const { id = '' } = useParams();
  const { data, refetch, isFetching } = useQueryGetContributionNotes(id);
  const listNotes = getArrayDefault(data?.data);

  return (
    <Stack direction="column" spacing={2}>
      <Typography align="left" variant="h6">
        Note From Admin
      </Typography>
      {listNotes.map((note, index) => {
        return (
          <NoteItem
            key={`contribute-note-from-admin-${note.id}-${index}`}
            note={note}
            refetch={refetch}
            isFetchingList={isFetching}
          />
        );
      })}
    </Stack>
  );
};

export default NoteFromAdmin;
